import React from "react";
import Icon from "./Icon";
export default function Pin(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M8.6451 3.68982C7.18426 5.17537 7.18426 7.58391 8.6451 9.06946C10.1059 10.555 12.4744 10.555 13.9352 9.06946C15.3961 7.58391 15.3961 5.17536 13.9352 3.68982C12.4744 2.20427 10.1059 2.20427 8.6451 3.68982Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.29 21V11.02"
  }));
}
Pin.displayname = "Pin";
//# sourceMappingURL=Pin.js.map